import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-treelist-text-cell',
  template: `<span>{{ value }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreelistTextCellComponent {
  @Input() value: any;
}
